import { useState } from "react"

import { X } from "lucide-react"

import { Field, FieldError } from "@/components/ui/Field"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select"

interface GradeStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

export const GRADE_OPTIONS = [
  { value: "Kindergarten", label: "Kindergarten" },
  { value: "1st Grade", label: "1st Grade" },
  { value: "2nd Grade", label: "2nd Grade" },
  { value: "3rd Grade", label: "3rd Grade" },
  { value: "4th Grade", label: "4th Grade" },
  { value: "5th Grade", label: "5th Grade" },
  { value: "6th Grade", label: "6th Grade" },
  { value: "7th Grade", label: "7th Grade" },
  { value: "8th Grade", label: "8th Grade" },
  { value: "9th Grade", label: "9th Grade" },
  { value: "10th Grade", label: "10th Grade" },
  { value: "11th Grade", label: "11th Grade" },
  { value: "12th Grade", label: "12th Grade" },
]

export function GradeStep({ value, onChange, onValidation }: GradeStepProps) {
  const [touched, setTouched] = useState(false)
  const hasError = touched && !value

  function handleValueChange(newValue: string) {
    onChange(newValue)
    setTouched(true)
    onValidation?.(true)
  }

  return (
    <div className="tw-text-center tw-space-y-6 tw-pt-16">
      <h2 className="tw-text-3xl tw-pb-3 tw-font-bold tw-text-gray-800">
        What grade level should this be leveled at?
      </h2>

      <Field>
        <Select value={value} onValueChange={handleValueChange}>
          <SelectTrigger
            className={`tw-w-full tw-max-w-lg tw-mx-auto tw-px-6 tw-py-4 tw-border-2 tw-border-dashed tw-rounded-sm tw-text-center tw-text-base tw-text-gray-500 placeholder:tw-text-gray-400 placeholder:tw-whitespace-pre-line tw-transition-all tw-resize-none focus:tw-outline-none focus:tw-ring-2 ${
              hasError
                ? "!tw-border-red-300 tw-bg-red-50 focus:tw-ring-red-500"
                : "!tw-border-emerald-600 focus:tw-border-emerald-800 focus:tw-ring-emerald-600"
            }`}
          >
            <SelectValue placeholder="Select grade level..." />
          </SelectTrigger>
          <SelectContent>
            {GRADE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {hasError && (
          <FieldError>
            <span className="tw-flex tw-justify-center tw-text-sm tw-items-center tw-gap-1 tw-pt-2">
              <X className="tw-w-4 tw-h-4" />
              Please select a grade level
            </span>
          </FieldError>
        )}
      </Field>
    </div>
  )
}
